import { render } from "./Message.vue?vue&type=template&id=53051dc6&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=53051dc6&lang=css"
import "./Message.vue?vue&type=style&index=1&id=53051dc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53051dc6"

export default script